"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArticlesSectionWrapper = exports.Alert = void 0;
var _mui = require("@ori-ui/mui");
const Alert = exports.Alert = (0, _mui.styled)(_mui.Alert)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(2)
    };
});
const ArticlesSectionWrapper = exports.ArticlesSectionWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(0, 3)
    };
});
